import React, { useEffect, useContext } from "react";
import { CallAPI } from "services/API";
import { DeviceContext } from 'utils/Device/DeviceContext';
import TableWithContainer from "utils/Table/TableWithContainer";
import { Grid } from "@material-ui/core";

export default function Application_Advanced(props) {
    const device = useContext(DeviceContext);
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", "/Advanced/GetApplications", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            groupBy: props.groupBy
        });

        if (response) {
            const formattedResponse = response.map((row) => [
                row.groupBy,
                integer.format(row.total),
                integer.format(row.online),
                integer.format(row.crc),
                integer.format(row.agency),
            ]);

            setData(formattedResponse);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <Grid container>
            <Grid item lg={3} xs={false} />
            <Grid item lg={6} xs={12}>
                <TableWithContainer
                    title="APPLICATIONS"
                    exportName="Applications"
                    loading={loading}
                    rowsPerPage={32}
                    fixedColumns={1}
                    style={{
                        Title: { lineHeight: "1em", fontSize: device.isMobile ? "1.3em" : "2.5em" },
                        Table: {
                            Header: { textAlign: "left", minWidth: "120px" },
                            Body: { textAlign: "left" },
                            Footer: { textAlign: "left" }
                        }
                    }}
                    headers={[[
                        props.groupBy, "Total", "Online", "CRC", "Agency"
                    ]]}
                    rows={data.filter(x => x[0] !== "Total")}
                    footers={data.filter(x => x[0] === "Total")}
                />
            </Grid>
        </Grid>
    );
}
